import { mdiHelpCircleOutline } from '@mdi/js'

export default {
  title: 'FAQ',
  to: 'faq-school',
  icon: mdiHelpCircleOutline,
  resource: 'FaqSchool',
  action: 'read',
}
